import styled from "styled-components";

export const UserMenuHeaderDefaultBox = styled.div`
  position: relative;
  flex: unset;
  padding: 1.4rem 0 1.4rem 0;
  background-color: ${({theme}) => theme.colors.background};
`
